<template>
    <div class="base-info">
        <QS-h4-title title="订单基本信息" />
        <el-tabs v-model="activeName">
            <el-tab-pane label="基础信息" name="baseInfo">
                <QS-column-box
                    :source="baseInfoSource"
                    :list="baseInfoList"
                    separator=":"
                ></QS-column-box>
            </el-tab-pane>
            <el-tab-pane label="人员及证照信息" name="personInfo">
                <div v-for="(item, index) in insureInfoConfigList" :key="index" class="person-info">
                    <div class="person-info-title">{{ item.title }}</div>
                    <QS-column-box
                        :source="personInfoSource"
                        :column="2"
                        :list="item.list"
                        separator=":"
                    >
                        <template slot="idCard" slot-scope="scope">
                            <div v-if="personalInfoImageSource[scope.privateKey].length">
                              <el-image
                                class="id-card-image"
                                v-for="
                                (_, index) in personalInfoImageSource[scope.privateKey].length"
                                :key="index"
                                :src="personalInfoImageSource[scope.privateKey][index]"
                                :preview-src-list="
                                [personalInfoImageSource[scope.privateKey][index]]"
                            ></el-image>
                            </div>
                            <div v-else>- -</div>
                        </template>
                    </QS-column-box>
                </div>
            </el-tab-pane>
            <el-tab-pane label="保险信息" name="insuranceInfo">
              <QS-column-box
                :source="orderTabDetail"
                :list="insureInfoList"
                separator=":"
              >
              </QS-column-box>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script setup>
import { ref, toRefs, computed } from 'vue'
import { useEchoUploadFileData } from '@/utils/useUploadCommon'

const transformImg = useEchoUploadFileData()

const props = defineProps({
  orderTabDetail: {
    type: Object,
    default: () => ({}),
  },
})

const { orderTabDetail } = toRefs(props)

const activeName = ref('baseInfo')

// 基础信息
const baseInfoSource = computed(() => {
  return {
    adCodeName: orderTabDetail.value.adCodeName,
    modelName: orderTabDetail.value.modelName,
    telephone: orderTabDetail.value.telephone,
    remark: orderTabDetail.value.remark,
    brandName: orderTabDetail.value.brandName,
    seriesName: orderTabDetail.value.seriesName,
  }
})

const baseInfoList = [
  {
    key: 'adCodeName',
    name: '报价城市',
  },
  {
    key: 'brandName',
    name: '品牌',
  },
  {
    key: 'seriesName',
    name: '车系',
  },
  {
    key: 'modelName',
    name: '车型',
  },
  {
    key: 'telephone',
    name: '联系电话',
  },
  {
    key: 'remark',
    name: '备注',
  },
]

// 证照文字信息
const personInfoSource = computed(() => {
  return {
    // 投保人
    insureApplicantName: orderTabDetail.value.insureApplicantName,
    insureApplicantTelephone: orderTabDetail.value.insureApplicantTelephone,

    // 被保险人
    insureUseName: orderTabDetail.value.insureUseName,
    insureUseTelephone: orderTabDetail.value.insureUseTelephone,

    // 车主信息
    driverName: orderTabDetail.value.driverName,
    driverTelephone: orderTabDetail.value.driverTelephone,
  }
})

// 证照图片信息
const insureInfoConfigList = [
  {
    title: '投保人信息',
    list: [
      {
        key: 'insureApplicantName',
        name: '投保人姓名',
      },
      {
        key: 'insureApplicantTelephone',
        name: '投保人手机号',
      },
      {
        key: 'idCard',
        name: '投保人证照',
        privateKey: 'insureIdCard',
      },
    ],
  },
  {
    title: '被保人信息',
    list: [
      {
        key: 'insureUseName',
        name: '被保人姓名',
      },
      {
        key: 'insureUseTelephone',
        name: '被保人联系电话',
      },
      {
        key: 'idCard',
        name: '被保人证照',
        privateKey: 'insureUseIdCard',
      },
    ],
  },
  {
    title: '车主信息',
    list: [
      {
        key: 'driverName',
        name: '车主姓名',
      },
      {
        key: 'driverTelephone',
        name: '车主联系电话',
      },
      {
        key: 'idCard',
        name: '车主证照',
        privateKey: 'driverIdCard',
      },
    ],
  },
  {
    title: '营业执照信息',
    list: [
      {
        key: 'idCard',
        name: '营业执照',
        privateKey: 'businessLicense',
      },
    ],
  },
]

const personalInfoImageSource = computed(() => {
  return {
    insureIdCard: [
      transformImg(orderTabDetail.value.insureApplicantIdcardFront)[0],
      transformImg(orderTabDetail.value.insureApplicantIdcardBack)[0],
    ],
    insureUseIdCard: [
      transformImg(orderTabDetail.value.insureUseIdcardFront)[0],
      transformImg(orderTabDetail.value.insureUseIdcardBack)[0],
    ],
    driverIdCard: [
      transformImg(orderTabDetail.value.driverIdcardFront)[0],
      transformImg(orderTabDetail.value.driverIdcardBack)[0],
    ],
    businessLicense: orderTabDetail.value.businessLicense ?
      transformImg(orderTabDetail.value.businessLicense) : [],
  }
})


// 保险信息
const insureInfoList = [
  {
    key: 'insuranceType',
    name: '投保险种',
  },
  {
    key: 'driverInsurance',
    name: '司机险保额',
  },
  {
    key: 'tripleInsurance',
    name: '第三者责任险保额',
  },
  {
    key: 'scratchInsurance',
    name: '划痕险保额',
  },
  {
    key: 'cdw',
    name: '车损险',
  },
]

</script>

<style lang="scss" scoped>
.person-info-title {
    font-size: 14px;
    font-weight: 500;
    color: #000000;
    margin-bottom: 16px;
}
.id-card-image {
    width: 116px;
    height: 116px;
    margin-right: 16px;
}
</style>
